import { render, staticRenderFns } from "./SubGoalWidgetPreview.vue?vue&type=template&id=4ded0ffa"
import script from "./SubGoalWidgetPreview.vue?vue&type=script&lang=js"
export * from "./SubGoalWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports